module.exports = __webpack_public_path__ + "img/B23-20190415_04.263ebf2d.jpg";